import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { VerifyEmailService } from '../../../services/auth/verify-email.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
})
export class VerifyEmailComponent {
  public status: 'Verified' | 'NotVerified' | 'Verifying' = 'Verifying';

  constructor(route: ActivatedRoute, service: VerifyEmailService) {
    route.queryParamMap.subscribe(map => {
      if (map && map.has('token')) {
        this.status = 'Verifying';
        service.verify(map.get('token')).subscribe(
          () => (this.status = 'Verified'),
          () => (this.status = 'NotVerified'),
        );
      } else {
        this.status = 'NotVerified';
      }
    });
  }
}
